// extracted by mini-css-extract-plugin
module.exports = {"productDetails":"ProductDetails_productDetails__nMu6A","productInfo":"ProductDetails_productInfo__OQD07","tagsTitleContainer":"ProductDetails_tagsTitleContainer__yZfsI"};